export function AboutPage() {
    return (
        <div>About page</div>
    )
}